import React from 'react';

const MeasureIconActive = ({ ...props }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_7449_24533)">
      <path
        d="M6.56543 24.9952V21.3952M11.0783 24.9952V20.5952M15.5911 24.9952V21.3952M20.5141 24.9952V20.5952M25.027 24.9952V21.3952"
        stroke="#003E7D"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M2.46387 19V24.2C2.46387 24.4667 2.62797 25 3.28438 25C3.94079 25 20.5151 25 28.7203 25C28.9938 25 29.5408 24.84 29.5408 24.2C29.5408 23.56 29.5408 20.4667 29.5408 19"
        stroke="#003E7D"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24.2021 11.8035H29.9457"
        stroke="#003E7D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.0713 9L29.9431 11.8L27.0713 14.6"
        stroke="#003E7D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.79144 11.8035H2.04785"
        stroke="#003E7D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.91965 14.6L2.04785 11.8L4.91965 9"
        stroke="#003E7D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7449_24533">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MeasureIconActive;
